import script from "./UsersAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersAdmin.vue?vue&type=script&setup=true&lang=js"

import "./UsersAdmin.vue?vue&type=style&index=0&id=a5720188&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5720188"]])

export default __exports__